import { MENU_ITEMS, MENU_VIEW_ITEMS, USER_MENU_ITEMS } from "./menuOptions"

// Helper function to extract routes from nested menu structure
export const getAllRoutes = (menuItems: typeof MENU_ITEMS) => {
  const routes: Record<string, string> = {}

  Object.entries(menuItems).forEach(([groupKey, group]) => {
    if (typeof group === "string") {
      // Direct route
      routes[groupKey] = group
    } else if (group.children) {
      // Nested routes
      Object.entries(group.children).forEach(([routeKey, routePath]) => {
        routes[routeKey] = routePath
      })
    }
  })

  return routes
}

export const ROUTES = getAllRoutes({
  ...MENU_ITEMS,
  ...MENU_VIEW_ITEMS,
  ...USER_MENU_ITEMS,
})
